export default __webpack_public_path__ + "static/media/postSample.2d4cae8e.jpeg";